import { css, html, LitElement } from "lit";
import { customElement, state } from "lit/decorators.js";

type item = {
    id: string;
    handle: string;
    title: string;
    featured_image: string;
    price: number;
    compare_at_price: number;
};

@customElement("recently-viewed")
export class RecentlyViewed extends LitElement {
    constructor() {
        super();

        const toParse = this.querySelector("script");

        if (!toParse) {
            console.error(
                "No product data found for recently viewed component.",
            );
            return;
        }
        const parsed = JSON.parse(toParse.innerText);
        const dataLimit = this.getAttribute("data-limit");

        const limit = dataLimit !== null ? Number.parseInt(dataLimit, 10) : 10;
        this.addCurrentProductToList(parsed, limit);
    }

    static styles = [
        css`
        .card {
          @media screen and (min-width: 990px) {
            max-width: 24.5%;
            min-width: 24.5%;
          }
          @media screen and (max-width: 989px) {
            max-width: 49%;
            min-width: 49%;
          }
          scroll-snap-align: center;
          .card__image {
            width: 100%;
          }
          .card__title {
            font-size: 1.3rem;
          }
          .card__link {
            color: inherit;
            text-decoration: none;
            s {
              color: rgba(var(--color-foreground),.75);
              font-size: 1.3rem;
            }
          }
          .card__link:hover .card__title {
            text-decoration: underline;
          }
        }
        .card-container {
          display: flex;
          padding: 0px;
          overflow-x: auto;
          position: relative;
          scroll-behavior: smooth;
          scroll-snap-type: x mandatory;
          list-style: none;
        }

        .grid {
          column-gap: var(--grid-desktop-horizontal-spacing);
          row-gap: var(--grid-desktop-vertical-spacing);

          &::-webkit-scrollbar {
            display: none;
          }
        }
        .heading {
          font-weight: 400;
          text-align: center;
        }

        recently-viewed {
          position: relative;
        }

        .slider-buttons {
          display: flex;
          justify-content: space-between;
          position: absolute;
          width: 100%;
          top: 50%;
          align-items: center;
          opacity: 0.8;
          img {
            border-radius: 3px;
          }
        }

        .slider-button {
          position: absolute;
          padding: 0;
          border: none;
          cursor: pointer;
        }

        .slider-button--prev {
          @media screen and (min-width: 990px) {
            left: -1rem;
          }
          @media screen and (max-width: 989px) {
            left: 1rem;
          }
        }

        .slider-button--next {
          @media screen and (min-width: 990px) {
            right: -1rem;
          }
          @media screen and (max-width: 989px) {
            right: 1rem;
          }
        }
    `,
    ];

    @state()
    private _recentlyViewedItems: Array<item> = [];

    render() {
        return html`
      <h2 class="heading">Recently Viewed</h2>
      <div>
        <ul class="card-container grid">
          ${this._recentlyViewedItems.map(
              (item: item) =>
                  html`
              <li class="card">
                <a class="card__link" href="/products/${item.handle}">
                  <img class="card__image" src="${item.featured_image}" alt="${item.title} product photo" />
                  <div class="card__title">${item.title}</div>
                  <s>${item.compare_at_price && "$"}${item.compare_at_price && item.compare_at_price / 100}</s>
                  <span>$${item.price / 100}</span>
                </a>
              </li>`,
          )}
        </ul>
        <div class="slider-buttons no-js-hidden quick-add-hidden">
          <button @click="${this.prevSlide}" class="slider-button slider-button--prev" name="previous" aria-label="previous"><img loading="lazy" src="${this.getAttribute("data-prev-img")}" alt=""></button>
          <button @click="${this.nextSlide}" class="slider-button slider-button--next" name="next" aria-label="next"><img loading="lazy" src="${this.getAttribute("data-next-img")}" alt=""></button>
        </div>
      </div>
    `;
    }

    nextSlide = (_e: Event) => {
        this.renderRoot.querySelector(".card-container").scrollBy(50, 0);
    };
    prevSlide = (_e: Event) => {
        this.renderRoot.querySelector(".card-container").scrollBy(-50, 0);
    };

    addCurrentProductToList = (parsedJson, limit = 4) => {
        const storedRecentItems: string =
            localStorage.getItem("recentlyViewed");
        let storedItemArray = [];

        if (storedRecentItems) storedItemArray = JSON.parse(storedRecentItems);

        let duplicate: boolean = false;
        let duplicateIndex: number = 0;

        storedItemArray.forEach((item: item, index) => {
            if (parsedJson.id === item.id) {
                duplicate = true;
                duplicateIndex = index;
            }
        });

        // If item is already in the list, move it to the front, else add it.
        if (duplicate)
            storedItemArray.unshift(
                storedItemArray.splice(duplicateIndex, 1)[0],
            );
        else storedItemArray.unshift(parsedJson);

        if (storedItemArray.length > limit) storedItemArray.length = limit;

        this._recentlyViewedItems = storedItemArray;
        localStorage.setItem("recentlyViewed", JSON.stringify(storedItemArray));
    };
}
